// Gedelegeerde events zonder jQuery. `handler` krijgt het matchende element
// als `this` (zoals jQuery's delegated .on). NB: focus/blur bubbelen niet —
// gebruik focusin/focusout.
export function on (event, selector, handler) {
  document.addEventListener(event, function (e) {
    const m = e.target.closest(selector)
    if (m) handler.call(m, e)
  })
}

// Escape user-origin strings before interpolating them into an innerHTML /
// insertAdjacentHTML template. Covers text nodes and quoted attributes, so a
// crafted unit/queue/URL value can't break out and execute. Mirrors the local
// `esc()` in schedule_grid.js; use this shared one in new code.
export function escapeHtml (s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ))
}

// Native Bootstrap 5-modal tonen/verbergen (geen jQuery-brug).
// Werkt voor modals én drawers (.offcanvas) — de vijf configuratieformulieren
// zijn drawers sinds de GUI-modernisering.
function overlayFor (el) {
  if (!el || !window.bootstrap) return null
  return el.classList.contains('offcanvas')
    ? window.bootstrap.Offcanvas.getOrCreateInstance(el)
    : window.bootstrap.Modal.getOrCreateInstance(el)
}
export function showModal (id) {
  const o = overlayFor(document.getElementById(id)); if (o) o.show()
}
export function hideModal (id) {
  const o = overlayFor(document.getElementById(id)); if (o) o.hide()
}
